/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_1Inputs */

const en_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const es_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir`)
};

const fr_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager`)
};

const de_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

const ja_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シェア`)
};

const zh_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享`)
};

const ar_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاركة`)
};

const id_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan`)
};

const it_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi`)
};

const ru_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поделиться`)
};

const pt_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar`)
};

const ko_share_1 = /** @type {(inputs: Share_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공유`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Share_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const share_1 = /** @type {((inputs?: Share_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_1(inputs)
	if (locale === "es") return es_share_1(inputs)
	if (locale === "fr") return fr_share_1(inputs)
	if (locale === "de") return de_share_1(inputs)
	if (locale === "ja") return ja_share_1(inputs)
	if (locale === "zh") return zh_share_1(inputs)
	if (locale === "ar") return ar_share_1(inputs)
	if (locale === "id") return id_share_1(inputs)
	if (locale === "it") return it_share_1(inputs)
	if (locale === "ru") return ru_share_1(inputs)
	if (locale === "pt") return pt_share_1(inputs)
	return ko_share_1(inputs)
});